import { toBlob } from 'html-to-image';
import axios from '@/axios';
import { irstore } from '@/fetch/interface';
import { resolvePageId } from '@rebuild/utils/context';
import store from '@/store';

const doReload = () => {
	window.location.reload();
};

export const screenShot = async (options = {}) => {
	console.log('🚀 ~ screenShot ~ options:', options);
	try {
		// 等待目标元素存在
		const element = document.querySelector('.layout-container');

		console.log('开始截取元素...', element);

		if (!element) {
			throw new Error('找不到目标元素 .layout-container');
		}

		// 检查元素是否包含图片
		const images = element.querySelectorAll('img');
		console.log('元素中包含的图片数量:', images.length);

		// 记录原始图片状态
		const originalImages = [];
		images.forEach((img, index) => {
			originalImages[index] = {
				src: img.src,
				style: img.style.cssText
			};

			if (!img.complete || img.naturalHeight === 0) {
				console.warn('发现未加载图片，设置占位符:', img.src);
				// 使用简单的灰色占位符图片
				img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
				img.style.background = '#f5f5f5';
				img.style.border = '1px solid #ddd';
				img.style.minWidth = '200px';
				img.style.minHeight = '150px';
				img.style.display = 'block';
			}
		});

		// 清理DOM中的无效选择器
		const modifiedAttributes = [];

		try {
			const allElements = element.querySelectorAll('*');
			allElements.forEach(el => {
				// 备份并清理无效ID
				if (el.id && (el.id.includes('#') || el.id.includes(' ') || el.id === '' || el.id.startsWith('#'))) {
					console.warn('清理无效ID:', el.id);
					modifiedAttributes.push({
						element: el,
						attribute: 'id',
						originalValue: el.id
					});
					el.removeAttribute('id');
				}

				// 备份并清理包含特殊字符的href属性
				if (el.hasAttribute('href') && el.getAttribute('href').includes('#')) {
					const originalHref = el.getAttribute('href');
					if (originalHref.startsWith('#') && originalHref.length > 1) {
						// 如果是锚点链接，记录并移除
						console.warn('清理锚点链接:', originalHref);
						modifiedAttributes.push({
							element: el,
							attribute: 'href',
							originalValue: originalHref
						});
						el.removeAttribute('href');
					}
				}

				// 清理xlink:href属性
				if (el.hasAttribute('xlink:href')) {
					const originalXlinkHref = el.getAttribute('xlink:href');
					console.warn('清理xlink:href:', originalXlinkHref);
					modifiedAttributes.push({
						element: el,
						attribute: 'xlink:href',
						originalValue: originalXlinkHref
					});
					el.removeAttribute('xlink:href');
				}
			});
		} catch (e) {
			console.warn('DOM清理过程中出现错误，跳过清理:', e);
		}

		console.log('图片状态检查完成，DOM清理完成，开始截图');

		const blob = await toBlob(element, {
			width: element.offsetWidth,
			height: element.offsetHeight * 0.4,
			backgroundColor: '#fff', // 设置默认白色背景
			pixelRatio: 2,
			quality: 0.9, // 降低质量，提高兼容性
			skipFonts: false, // 跳过字体处理，减少错误
			useCORS: true, // 启用CORS支持
			allowTaint: true, // 允许跨域图片污染画布
			filter: node => {
				// 过滤掉可能导致污染的元素
				if (node.nodeType === Node.ELEMENT_NODE) {
					const el = node;

					// 只跳过有问题的Canvas元素
					if (el.tagName === 'CANVAS') {
						const canvas = el;
						// 检查Canvas是否有问题
						if (canvas.width === 0 || canvas.height === 0) {
							console.warn('跳过0尺寸Canvas元素');
							return false;
						}
						// 检查Canvas是否被污染
						try {
							canvas.toDataURL(); // 尝试导出，如果被污染会抛出错误
							console.log('保留正常Canvas元素');
							return true; // Canvas正常，保留
						} catch (e) {
							console.warn('跳过被污染的Canvas元素:', e.message);
							return false; // Canvas被污染，跳过
						}
					}

					// 跳过0尺寸元素
					if (el.offsetWidth === 0 || el.offsetHeight === 0) {
						return false;
					}
				}
				return true;
			}
		});

		// 恢复被修改的属性
		modifiedAttributes.forEach(({ element, attribute, originalValue }) => {
			try {
				element.setAttribute(attribute, originalValue);
			} catch (e) {
				console.warn('恢复属性失败:', attribute, e);
			}
		});

		// 恢复原始图片状态
		images.forEach((img, index) => {
			if (originalImages[index]) {
				img.src = originalImages[index].src;
				img.style.cssText = originalImages[index].style;
			}
		});
		console.log('所有状态已恢复');

		// 方法1: 将blob转换为File对象
		const file = new File([blob], 'screenshot.png', {
			type: blob.type || 'image/png'
		});

		store
			.dispatch('ossFileUploadNew', {
				options: {
					file,
					type: 'img'
				}
			})
			.then(res => {
				axios
					.post(
						irstore.saveScreenshotImage,
						{
							imageUrl: res.viewurl,
							pageId: resolvePageId()
						},
						{
							headers: {
								skipAuth: true,
								temporaryToken: options.token
							}
						}
					)
					.then(res => {
						doReload();
						console.log('🚀 ~ screenShot ~ saveScreenshotImage res:', res);
					})
					.catch(err => {
						doReload();
						console.error('保存截图失败:', err);
					});
			});
	} catch (error) {
		doReload();
		console.error('截图失败:', error);
		throw error;
	}
};
